// limites
export const LIMIT_TEXT_POST: number = Number(process.env.REACT_APP_LIMIT_TEXT_POST_URL) || 1000;
export const LIMIT_TEXT_COMMENT: number = Number(process.env.REACT_APP_LIMIT_TEXT_COMMENT_URL) || LIMIT_TEXT_POST;
export const LIMIT_TEXT_REPORT: number = Number(process.env.REACT_APP_LIMIT_TEXT_REPORT_URL) || LIMIT_TEXT_POST;
export const LIMIT_NAME_COMMUNITY: number = Number(process.env.REACT_APP_LIMIT_NAME_COMMUNITY) || 100;
export const LIMIT_DESCRIPTION_COMMUNITY: number = Number(process.env.REACT_APP_LIMIT_DESCRIPTION_COMMUNITY) || 200;
export const LIMIT_TEXT_ADS: number = 500;
export const PRICE_PER_VIEWS_ADS: number = 0.05;
export const LIMIT_NAME_ADS: number = LIMIT_NAME_COMMUNITY;
export const MAX_BAN_DAYS: number = Number(process.env.REACT_APP_MAX_BAN_DAYS) || 100; //maximo de dias que pode banir
export const LIMIT_REQUEST_COMMENTS: number = Number(process.env.REACT_APP_LIMIT_TEXT_REPORT_URL) || 12;
export const LIMIT_REQUEST_LIKES: number = Number(process.env.REACT_APP_LIMIT_REQUEST_LIKES) || 20 ;
export const LIMIT_REQUEST_FOLLOWERS: number = Number(process.env.REACT_APP_LIMIT_REQUEST_FOLLOWERS) || 20;

export const EFI_ACCOUNT_CODE: number = Number(process.env.REACT_APP_EFI_ACCOUNT_CODE) || 20;

export const PACOCA_AI_URL = process.env.REACT_APP_PACOCA_AI_URL ?? "http://localhost:8082" 